/**
 * Owner: Masa Bayu
 * File: id.ts
 * Date:Time: 2026-09-14 20:33
 * Description: Stable identity helpers for QXP publication objects.
 */
export function createQXPId(prefix) {
    return `${prefix}_${crypto.randomUUID()}`;
}
//# sourceMappingURL=id.js.map